var ActivityTile = require("components/writing/activities/ActivityTile");
var ResponseTile = require("components/writing/responses/ResponseTile");
var Spinner = require("components/utility/Spinner");
var Masonry = require("react-masonry-component");

require("utility/board.scss");

class Board extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	render() {
		if (this.props.type == Board.STUDENT_ACTIVITIES) {
			var tileContent = this.props.items.map(function(item){ 
				return (
					<ActivityTile item={ item } key={ item.id } forStudents={ true }
						onClick={ this.props.onTileClick } 
						hideAssignAction={ true } />
				);
			}.bind(this));

		} else if (this.props.type == Board.TEACHER_ACTIVITIES) {
			var tileContent = this.props.items.map(function(item){
				return (
					<ActivityTile item={ item } key={ item.id }
						onClick={ this.props.onTileClick }
						onItemAssign={ this.props.onItemAssign }
						previewParameters={ this.props.previewParameters } />
				);
			}.bind(this));

		} else if (this.props.type == Board.TEACHER_RESPONSES) {
			var tileContent = this.props.items.map(function(item) {
				return (
					<ResponseTile response={ item } key={ item.id }
						userName={ item.input_name }
						onRemove={ this.props.onRemove }
						allowGrading={ true } onClick={ this.props.onTileClick } />
				);
			}.bind(this));

		}

		if (this.props.loading) {
			var spinner = (<Spinner scale={ 1.7 } />);
		}

		var masonryOptions = { gutter: 15 }

		var className = "tileGridWrapper";
		if (this.props.narrowBoard) {
			className += " narrowGrid";
		}

		return (
			<div className={ className } ref="wrapper">
				<Masonry updateOnEachImageLoad={ true } options={ masonryOptions } ref="masonry" >
				    { tileContent }
			  	</Masonry>
			  	{ spinner }
			</div>
		);
	}

	checkScroll() {
		if (!this.props.loading && this.props.onScrollToBottom) {
			var $wrapper = $(this.refs.wrapper);
			var threshold = 300;
			var lim = $wrapper.offset().top + $wrapper.height();
			var loc = $(window).scrollTop() + $(window).height();
			if (loc + threshold > lim) {
				this.props.onScrollToBottom();
			}			
		}
	}

	refreshMasonry() {
		this.refs.masonry.forceUpdate();
	}

	componentDidMount() {
		$(window).scroll(this.checkScroll);
		$(window).on("masonry-update", this.refreshMasonry);
	}

	componentWillUnmount() {
		$(window).off("scroll", this.checkScroll);
		$(window).off("masonry-update");
	}
};

Board.STUDENT_NEWS_FEED = "StudentNewsFeed";
Board.STUDENT_ACTIVITIES = "StudentActivities";
Board.TEACHER_ACTIVITIES = "TeacherActivities";
Board.CLASS_NEWS_FEED = "ClassNewsFeed";
Board.TEACHER_RESPONSES = "TeacherResponses";

Board.propTypes = StrictPropTypes({
	// What type of board this is
	type: PropTypes.string.isRequired,

	items: PropTypes.array.isRequired,

	// Show a spinner and block onEnd notices if this is true
	loading: PropTypes.bool,

	// Function to call once the user has scrolled to the bottom
	onScrollToBottom: PropTypes.func,

	// Function to call if a title is clicked on (passed on)
	onTileClick: PropTypes.func,

	// Function to call if a title is removed (passed on)
	onRemove: PropTypes.func,

	// Makes the board narrower
	narrowBoard: PropTypes.bool,

	/////// ActivityTile specific props ///////
	onItemAssign: PropTypes.func,		 // Call to assign and activity
	previewParameters: PropTypes.object,		 // Pass to ActivityTile
	hideAssignAction: PropTypes.bool,
});

module.exports = Board;



// WEBPACK FOOTER //
// ./modules/components/utility/Board.js